export default __webpack_public_path__ + "static/media/loader.c14df7c1.gif";